import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const hrRoutesDictionary = moduleRouteDictionaryFactory('hr', 'hrs', {
  list: 'list',
  create: 'create',
  createRole: 'create/role',
  detail: ':id',
  editAnagraphic: 'edit/:id/anagraphic',
  editAdditionalData: 'edit/:id/additional',
  editRole: 'edit/:id/role',
});
